import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "content-container",
  class: "content__container"
}
const _hoisted_2 = { class: "content__wrapper" }
const _hoisted_3 = {
  key: 2,
  class: "mobile__placeholder"
}

import WelcomeText from "@/components/content/WelcomeText.vue";
import CustomCursor from "@/components/CustomCursor.vue";
import LayoutNavbar from "@/components/Layout/Navbar.vue";
import { useContentStore } from "@/store/content";
import { useScrollerStore } from "@/store/scroller";
import { onBeforeMount, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pHome',
  setup(__props) {

const { navbarItems, activateByHash, isMobile } = useContentStore();
const { createListeners } = useScrollerStore();

onMounted(() => {
  createListeners();
  activateByHash(true, false);
});

return (_ctx: any,_cache: any) => {
  const _directive_glitched = _resolveDirective("glitched")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isMobile)())
      ? (_openBlock(), _createBlock(WelcomeText, { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(isMobile)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LayoutNavbar),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbarItems), (navbarItem, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(navbarItem.view), { key: index }))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isMobile)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("p", null, null, 512), [
            [_directive_glitched, `Mobile version coming soon`]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})